(function WebHotelSearchForm($, HE)
{
	"use strict";

	const form = {
		name: 'HotelSearch',
	};

	$(document).ready(function documentReady()
	{
		HE.Form.registerForm(form);
	});

	form.load = function load($form)
	{
		let max_guests_per_room = null;
		HE.Ajax.post('/Hotels/checkIfBedsOnlineIsIncludedInCurrentClient').then(function processed(response) {
			if (response.error) {
				// console.log(response.error);
			} else if (response.is_included === true) {
					max_guests_per_room = response.max_guests_per_room;
				}
		});

		const $search_config = $('#search-config'),
			$search_config_label = $('input.search-config-label'),
			$room_configs = $search_config.find('div[data-room]');

		HE.GooglePlaces($form.find('.destination-search'));

		$search_config.on('hide.bs.offcanvas', function setRoomConfigInputs()
		{
			let num_rooms = 0,
				num_adults = 0,
				num_children = 0,
				num_guests = 0,
				label;

			$room_configs.filter(':visible').each((i, room) => {
				const room_sel = '[data-room="' + i + '"]',
					_adults = parseFloat($(room_sel + ' .count[data-type="adults"]').html()),
					_children = parseFloat($(room_sel + ' .count[data-type="children"]').html());

				num_rooms++;
				num_adults   += _adults;
				num_children += _children;

				$(room_sel + ' input[name$="[num_adults]"]').val(_adults);
				$(room_sel + ' input[name$="[num_children]"]').val(_children);
			});

			num_guests = num_adults + num_children;
			label      = num_rooms + ' room' + ((num_rooms > 1) ? 's' : '');
			label      += ', ';
			label      += num_guests + ' guest' + ((num_guests > 1) ? 's' : '');
			$search_config_label.val(label);

		});

		$('.change-count').click(function changeLineItemCount()
		{
			let $self = $(this),
				$label = $self.siblings('.count'),
				new_val = parseFloat($label.html()),
				room_id = $self.parents('[data-room]').data('room'),
				adult_room_total = parseFloat($self.parents('[data-room]').find('span[data-type="adults"]').html()),
				children_room_total = parseFloat($self.parents('[data-room]').find('span[data-type="children"]').html()),
				new_val_combined = adult_room_total + children_room_total;

			if ($self.data('max')) {
				new_val += 1;
				new_val_combined++;
			}
			else {
				new_val -= 1;
				new_val_combined--;
			}


			if (new_val > $self.data('max')) {
				HE.StatusMessage('error', 'Cannot have more than ' + $self.data('max'));
				return;
			}

			if (new_val < $self.data('min')) {
				HE.StatusMessage('error', 'Cannot have less than ' + $self.data('min'));
				return;
			}

			if (max_guests_per_room !== null && (new_val_combined) > max_guests_per_room) {
				HE.StatusMessage('error', 'Cannot have more than ' + max_guests_per_room + ' guests total per room');
				return;
			}

			if ($label.data('type') === 'rooms') {
				setMaxRoomConfigs(new_val);
			}
			else if ($label.data('type') === 'children') {
				setChildConfig(room_id, new_val);
			}

			$label.html(new_val);
		});

		function setMaxRoomConfigs(max_rooms = 1)
		{
			$room_configs.each((i, room) => {
				const $room = $(room);

				if ($room.data('room') > (max_rooms - 1)) {
					$room.addClass('d-none');
					$room.find('input, select').prop('disabled', true);
				}
				else {
					$room.removeClass('d-none');
					$room.find('input, select').prop('disabled', false);
				}
			});
		}

		function setChildConfig(room_id, num_children = 0)
		{
			$room_configs
				.filter('[data-room="' + room_id + '"]')
				.find('.child-age')
				.each((i, child) => {
					const $child = $(child);

					if (i < num_children) {
						$child.removeClass('d-none');
						$child.find('select').prop('disabled', false);
					}
					else {
						$child.addClass('d-none');
						$child.find('select').prop('disabled', true);
					}
				});
		}

		$('#hotelsearch-checkin_checkout').on('apply.daterangepicker', function _checkIfSame(ev, picker) {
			const next_day = moment(picker.startDate, "DD-MM-YYYY").add(1, "days").format('MM/DD/YYYY'),
				next_val = moment(picker.startDate, "DD-MM-YYYY").add(1, "days").format('YYYY-MM-DD');

			if (picker.startDate.format("YYYY-MM-DD") === picker.endDate.format("YYYY-MM-DD")) {
				$('#hotelsearch-checkin_checkout').data('daterangepicker').setEndDate(next_day);

				$('#hotelsearch-check_out').val(next_val);
			}
		});
	};
}(jQuery, window.HE || {}));
